export const testAttributes = {
    ACCORDION_GROUP_CONTAINER: 'accordion-group-container',
    ACCORDION_GROUP_HEADLINES: 'accordion-group-headlines',
    ACCORDION_GROUP_LIST_CONTAINER: 'accordion-group-list-container',
};
